"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ConstructorBankSelectOption_1 = __importDefault(require("../ConstructorBankSelectOption"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../Button"));
var RangeSlider_1 = __importDefault(require("../../../RangeSlider"));
var MortgageButton_1 = __importDefault(require("../../../MortgageButton"));
var loanCalculation_1 = require("../../../../helpers/loanCalculation");
var currencyConverter_1 = require("../../../../helpers/currencyConverter");
var react_redux_1 = require("react-redux");
var currencySlice_1 = require("../../../../features/currencies/currencySlice");
var ErrorMsg_1 = __importDefault(require("../../../Validation/ErrorMsg"));
var semantic_ui_react_1 = require("semantic-ui-react");
var PersonalBank_1 = __importDefault(require("../PersonalBank"));
var PostViewContentTypes_1 = require("../../../../constants/PostViewContentTypes");
var numberHelpers_1 = require("../../../../helpers/numberHelpers");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MortgageForm = function (_a) {
    var region = _a.region, address = _a.address, district = _a.district, isDeveloper = _a.isDeveloper, freeApartments = _a.freeApartments, mortgage = _a.mortgage, propertyType = _a.propertyType;
    var t = react_i18next_1.useTranslation('common').t;
    var all = react_redux_1.useSelector(currencySlice_1.selectAllExchangeRates);
    var rate = react_redux_1.useSelector(currencySlice_1.selectExchangeRate);
    var currency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var defaultRange = 20;
    var defaultAnnualRate = '12';
    var defaultPrePayment = '15';
    var _b = react_1.useState([defaultRange]), range = _b[0], setRange = _b[1];
    var _c = react_1.useState(defaultAnnualRate), annualRate = _c[0], setAnnualRate = _c[1];
    var _d = react_1.useState(), monthlyPrice = _d[0], setMonthlyPrice = _d[1];
    var _e = react_1.useState(defaultPrePayment), prePayment = _e[0], setPrePayment = _e[1];
    var _f = react_1.useState(freeApartments[0]), selectedApartment = _f[0], setSelectedApartment = _f[1];
    var _g = react_1.useState(false), invalidPrePayment = _g[0], setInvalidPrePayment = _g[1];
    var _h = react_1.useState(), selectedBank = _h[0], setSelectedBank = _h[1];
    react_1.useEffect(function () {
        handleCalculate();
    }, [prePayment, annualRate, selectedApartment.value, currency]);
    react_1.useEffect(function () {
        if (prePayment) {
            setInvalidPrePayment(Number(prePayment) < 10 || Number(prePayment) > 90);
        }
    }, [prePayment]);
    react_1.useEffect(function () {
        if (selectedBank) {
            setPrePayment(selectedBank.min_prepayment);
            setAnnualRate(selectedBank.min_percent);
        }
    }, [selectedBank, selectedApartment.value]);
    var convertedCurrency = react_1.useMemo(function () {
        return (selectedApartment.price &&
            currencyConverter_1.convertToCurrency(selectedApartment.price, rate, all, currency, false));
    }, [selectedApartment.price, currency]);
    var handleInputChange = function (value) {
        setPrePayment(value);
    };
    var handleCalculate = function () {
        if (convertedCurrency &&
            Number(prePayment) >= 10 &&
            Number(prePayment) <= 90) {
            setMonthlyPrice(loanCalculation_1.handleLoanCalculator(convertedCurrency, prePayment, annualRate, range[0] * 12));
        }
        else {
            setInvalidPrePayment(true);
            setMonthlyPrice('');
        }
    };
    var handleSelectCurrentApartment = function (value) {
        var selectedApartment = freeApartments.find(function (item) { return item.value === value; });
        setSelectedApartment(selectedApartment);
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('ui form', styles_module_scss_1.default.mortgage_form) },
        react_1.default.createElement("div", { className: "ui two column centered grid" },
            react_1.default.createElement("div", { className: "two column row" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", null, t('POST_PREVIEW.MORTGAGE_SECTION.BANK_NAME')),
                        isDeveloper ? (react_1.default.createElement(ConstructorBankSelectOption_1.default, { mortgage: mortgage, setSelectedBank: function (data) {
                                return setSelectedBank(data);
                            }, selectedBank: selectedBank })) : (react_1.default.createElement(PersonalBank_1.default, null)))),
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", null, propertyType === PostViewContentTypes_1.SECTION_TYPES.HOUSE_INFO
                            ? t('POST_PREVIEW.MORTGAGE_SECTION.HOUSE_CODE')
                            : propertyType ===
                                PostViewContentTypes_1.SECTION_TYPES.APARTMENTS_INFO
                                ? t('POST_PREVIEW.MORTGAGE_SECTION.APARTMENT_CODE')
                                : propertyType ===
                                    PostViewContentTypes_1.SECTION_TYPES.COMMERCIAL_INFO
                                    ? t('POST_PREVIEW.MORTGAGE_SECTION.COMMERCIAL_CODE')
                                    : t('POST_PREVIEW.MORTGAGE_SECTION.APARTMENT_INFO')),
                        react_1.default.createElement(semantic_ui_react_1.Dropdown, { fluid: true, selection: true, className: styles_module_scss_1.default.dropdown, options: freeApartments, value: selectedApartment.value, selected: selectedApartment.value, disabled: !isDeveloper, onChange: function (event, data) {
                                return handleSelectCurrentApartment(String(data.value));
                            } })))),
            react_1.default.createElement("div", { className: "two column row" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", null, t('POST_PREVIEW.MORTGAGE_SECTION.RATE')),
                        react_1.default.createElement("input", { type: "text", value: annualRate, disabled: true }))),
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", null,
                            t('POST_PREVIEW.MORTGAGE_SECTION.PREPAYMENT'),
                            react_1.default.createElement("span", null, " (%)")),
                        react_1.default.createElement("input", { type: "text", placeholder: "%", value: prePayment, onChange: function (event) {
                                return handleInputChange(event.target.value);
                            } }),
                        invalidPrePayment && (react_1.default.createElement("div", { className: styles_module_scss_1.default.error_message },
                            react_1.default.createElement(ErrorMsg_1.default, { message: t('POST_PREVIEW.MORTGAGE_SECTION.INVALID_PREPAYMENT') })))))),
            react_1.default.createElement("div", { className: "one column row" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", { className: styles_module_scss_1.default.loan_range },
                            react_1.default.createElement("div", null,
                                t('POST_PREVIEW.MORTGAGE_SECTION.LOAN_TERM'),
                                react_1.default.createElement("p", null,
                                    range,
                                    " ",
                                    t('POST_PREVIEW.YEAR')))),
                        react_1.default.createElement(RangeSlider_1.default, { value: range, onChange: function (value) { return setRange(value); } })))),
            react_1.default.createElement("div", { className: "column row" },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.calculate_button },
                    react_1.default.createElement(Button_1.default, { variant: "outline", onClick: handleCalculate }, t('POST_PREVIEW.CALCULATE')))),
            react_1.default.createElement("div", { className: "two column row" },
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: "field" },
                        react_1.default.createElement("label", null, t('POST_PREVIEW.MORTGAGE_SECTION.MONTHLY_PRICE')),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.currency_monthly_mortgage },
                            react_1.default.createElement("i", { className: "icon-ic-" + currency }),
                            react_1.default.createElement("input", { type: "text", className: styles_module_scss_1.default.monthly_price, defaultValue: monthlyPrice &&
                                    numberHelpers_1.numberToDecimalString(numberHelpers_1.roundUp(monthlyPrice, currencyConverter_1.currencyPrecision[currency])), disabled: true })))),
                react_1.default.createElement("div", { className: "column" },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.mortgage_button },
                        react_1.default.createElement(MortgageButton_1.default, { region: region, address: address, district: district, price: selectedApartment.price, hasIcon: false })))))));
};
exports.default = MortgageForm;
